import React, { useEffect, useState } from 'react';
import Spinner from '../ogComponent/spinner';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Table from '../ogComponent/table';
import { IconPlus } from '@tabler/icons-react';

export default function SingleDayFullPunch() {
  const { userId } = useParams();
  const [product, setProduct] = useState([]);
  const [employee, setEmployee] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectDate, setSelectDate] = useState(dayjs());
  const [workedHours, setWorkedHours] = useState('');
  const [shiftWorkingHours, setShiftWorkingHours] = useState('');
  const [actualWorkedHours, setActualWorkedHours] = useState('');
  const [expectedCheckOut, setExpectedCheckOut] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [punchType, setPunchType] = useState('Clock-in');
  const [punchTime, setPunchTime] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const header = [
    { name: 'Si No', label: '#', active: true },
    { name: 'Date', label: 'Date', active: true },
    { name: 'Day', label: 'Day', active: true },
    { name: 'type', label: 'Type', active: true },
    { name: 'time', label: 'Time', active: true },
  ];

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // setSearchParams({ page: newPage });
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    const fetchAttendanceData = async () => {
      try {
        setLoading(true);
        const formattedDate = selectDate.format('YYYY-MM-DD');

        // Fetch attendance data
        const attendanceResponse = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/single-attendance/`,
          {
            params: { punch_date: formattedDate, employee__id: userId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Fetch worked hours
        const workedHoursResponse = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/employee-worked-hours/${userId}/`,
          {
            params: {
              start_date: formattedDate,
              end_date: formattedDate,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const attendanceData = attendanceResponse.data[0];
        const workedHoursData = workedHoursResponse.data;

        if (attendanceData) {
          setEmployee(attendanceData.employee_details);
          const formattedPunchData = attendanceData.punch_details.map((punch, index) => ({
            'Si No': index + 1,
            Date: attendanceData.punch_date,
            Day: attendanceData.day,
            type: punch.punch_direction,
            time: punch.punch_time,
          }));
          setProduct(formattedPunchData);
        } else {
          setProduct([]);
        }

        // Update worked hours and other fields from API response
        if (workedHoursData.worked_hours && workedHoursData.worked_hours.length > 0) {
          setWorkedHours(workedHoursData.worked_hours[0].worked_hours);
          setActualWorkedHours(workedHoursData.worked_hours[0].actual_worked_hours);
        } else {
          setWorkedHours('00:00:00');
          setActualWorkedHours('00:00:00');
        }

        setShiftWorkingHours(workedHoursData.shift_working_hours);
        setExpectedCheckOut(workedHoursData.expected_check_out);

        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
        setProduct([]);
        setWorkedHours('00:00:00');
        setActualWorkedHours('00:00:00');
        setShiftWorkingHours('00:00:00');
        setExpectedCheckOut('00:00:00');
      }
    };

    fetchAttendanceData();
  }, [selectDate, userId]);

  const handleModalSubmit = () => {
    console.log('Submitted punch:', {
      date: selectDate.format('YYYY-MM-DD'),
      type: punchType,
      time: punchTime,
    });
    setShowModal(false);
  };

  return (
    <div className="AttendanceContainer w-100 h-100 px-3 px-lg-4 pt-3">
      <h3 className="pt-2">Single Day Data</h3>

      <div className="empData">
        <p className="text-secondary m-0">
          Name: <span className="text-black">{employee.Name}</span>
        </p>
        <p className="m-0 text-secondary">
          Branch: <span className="text-black">{employee.Branch_name} - {employee.Branch_location}</span>
        </p>
        <p className="m-0 text-secondary">
          Position: <span className="text-black">{employee.Job_position}</span>
        </p>
        <p className="m-0 text-secondary">
          Phone: <span className="text-black">{employee.Phone}</span>
        </p>
        <p className="m-0 text-secondary">
          Email: <span className="text-black">{employee.Email}</span>
        </p>
      </div>

      <div className="d-flex w-100 gap-3 align-items-center justify-content-end">
        {/* <button className="btn btn-success" onClick={() => setShowModal(true)}>
          <IconPlus stroke={2} /> Add Punch
        </button> */}
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select a Date"
              value={selectDate}
              className="MuidatePicker1"
              onChange={(newValue) => setSelectDate(newValue)}
              renderInput={(params) => <input {...params} className="form-control" />}
            />
          </LocalizationProvider>
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : product.length > 0 ? (
        <>
          <div className="w-100 py-2 d-flex justify-content-center align-items-center">
            <div className="px-3 py-2 d-flex w-100 justify-content-around align-items-center rounded-2" style={{ backgroundColor: '#bfbdde' }}>
              <p className="mb-0">
                Total Hours: <span className="fw-semibold ps-2">{actualWorkedHours}</span>
              </p>
              <p className="mb-0">
                Working Hours: <span className="fw-semibold ps-2">{workedHours} <small>({shiftWorkingHours})</small></span>
              </p>
              <p className="mb-0">
                Expected Outing: <span className="fw-semibold ps-2">{expectedCheckOut}</span>
              </p>
            </div>
          </div>
          <Table
            header={header}
            product={product}
            loading={loading}
            onRowClick={() => { }}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-end position-relative" style={{ height: '50vh' }}>
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundImage: 'url(/assets/file.png)',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: 0.3,
            }}
          ></div>
          <p className="m-0 fw-light fs-5 position-relative">No Attendance or Leave Data!</p>
        </div>
      )}

      {/* Modal */}
      <div
        className={`modal fade ${showModal ? 'show d-block' : ''}`}
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: showModal ? 'rgba(0, 0, 0, 0.5)' : 'transparent' }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Punch</h5>
              <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="punchType" className="form-label">Punch Type</label>
                <select
                  id="punchType"
                  className="form-control"
                  value={punchType}
                  onChange={(e) => setPunchType(e.target.value)}
                >
                  <option>Clock-in</option>
                  <option>Clock-out</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="punchTime" className="form-label">Time</label>
                <input
                  type="time"
                  id="punchTime"
                  className="form-control"
                  value={punchTime}
                  onChange={(e) => setPunchTime(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleModalSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}